import { render, staticRenderFns } from "./newApplyForm.vue?vue&type=template&id=bbee47f6&scoped=true"
import script from "./newApplyForm.vue?vue&type=script&lang=js"
export * from "./newApplyForm.vue?vue&type=script&lang=js"
import style0 from "./newApplyForm.vue?vue&type=style&index=0&id=bbee47f6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbee47f6",
  null
  
)

export default component.exports